/* eslint-disable */
import { get } from 'lodash';
import { mapActions, mapGetters, mapState } from 'vuex';
import Contract from '@/models/contract';
import marketChangePrice from '@/components/market/market-change-price/market-change-price.vue';
import orderBookSushi from '@/components/purchase/sushi/order-book-sushi/order-book-sushi.vue';
import keyboardNumericSushi from '@/components/keyboard-numeric-sushi/keyboard-numeric-sushi.vue';
import keyboardNumericInputSushi from '@/components/keyboard-numeric-input-sushi/keyboard-numeric-input-sushi.vue';
import purchaseOfferValueSushi from '@/components/purchase/sushi/purchase-offer-value-sushi/purchase-offer-value-sushi.vue';
import purchaseQuantityValueSushi from '@/components/purchase/sushi/purchase-quantity-value-sushi/purchase-quantity-value-sushi.vue';
import {
  isContractOpen,
  isMarketClosed,
  isMarketDisabled, isMarketSettled,
} from '@/utils/helpers'
import { formMixin } from '@/components/forms/mixin';
import loaderMixin from '@/mixins/loader';
import { MODALS } from '@/components/app/app-modals/modals-constants';
import marketCharts from '@/components/market/market-detail-charts/market-detail-charts.vue';
import purchaseTradeTypeSwitcherSushi from '@/components/purchase/sushi/purchase-trade-type-switcher-sushi/purchase-trade-type-switcher-sushi.vue';
import relatedContractsSushi from '@/components//related-contracts-sushi/related-contracts-sushi.vue';
import { isMarketSingle } from '@/utils/helpers';
import purchaseOfferValuePickerMobileSushi from '@/components/purchase/sushi/purchase-offer-value-picker-mobile-sushi/purchase-offer-value-picker-mobile-sushi.vue';
import purchaseQuantityPickerMobileSushi from '@/components/purchase/sushi/purchase-quantity-picker-mobile-sushi/purchase-quantity-picker-mobile-sushi.vue';
import marketTradingUnavailableV2 from '@/components/market/v2/market-trading-unavailable-v2/market-trading-unavailable-v2.vue';
import store from '@/store';

const getDefaultBuyQuantity = () => {
  return store.getters['user/isLoggedIn'] ? 1 : 10;
}

export default {
  mixins: [
    formMixin,
    loaderMixin,
  ],
  components: {
    marketChangePrice,
    keyboardNumericSushi,
    keyboardNumericInputSushi,
    orderBookSushi,
    purchaseOfferValueSushi,
    purchaseQuantityValueSushi,
    marketCharts,
    purchaseTradeTypeSwitcherSushi,
    relatedContractsSushi,
    purchaseOfferValuePickerMobileSushi,
    purchaseQuantityPickerMobileSushi,
    marketTradingUnavailableV2,
  },
  props: {
    market: {},
    contract: {},
    showRelatedContracts: {
      type: Boolean,
      default: false
    },
    showContractCharts: {
      type: Boolean,
      default: false,
    },
    showOrderSlip: {
      type: Boolean,
      default: true,
    },
    disablePurchaseOfferWatchers: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pricePerShareUpdateCount: 0,
      pricePerShare: null,
      quantity: getDefaultBuyQuantity(),
      skipConfirmation: false,
      quantityError: null,
      inputSelected: null,
      submitDisabledBecauseOfSwitch: false,
      directionalOrderState: {
        yes: null,
        no: null,
      },
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop', 'isTradingEnabled', 'isAfterHours', 'isRegularMaintenance', 'isExtendedMaintenance']),
    ...mapState('trade', [
      'tradeOptions', 'cancelToggle', 'tradeSuccess',
      'masterTradeOptions'
    ]),
    componentName() {
      return this.$options.name ||
                 (this.$vnode && this.$vnode.componentOptions.tag) ||
                 "Unknown Component";
    },
    isMarketSingle() {
      return isMarketSingle(this.market);
    },
    isMarketDisabled() {
      return isMarketDisabled(this.market);
    },
    isMarketSettled() {
      return isMarketSettled(this.market);
    },
    isMarketClosed() {
      return isMarketClosed(this.market);
    },
    minimumOwnership() {
      return Math.max(get(this.contract, 'minimumClipSize', 1), 1);
    },
    showThresholdInfo() {
      return this.minimumOwnership > 1;
    },
    minQuantityValue() {
      if (this.tradeOptions.operationType === 'buy') {
        return (this.contractModel.userQuantity >= this.minimumOwnership)
          ? 1
          : Math.min(this.minimumOwnership, this.minimumOwnership - this.contractModel.userQuantity);
      } else {
        return (this.contractModel.userQuantity === 0)
          ? 1
          : (this.contractModel.userQuantity > this.minimumOwnership)
            ? 1
            : this.contractModel.userQuantity;
      }
    },
    maxQuantityValue() {
      if (this.tradeOptions.operationType === 'buy') {
        return 9999;
      } else {
        return (this.contractModel.userQuantity === 0)
          ? 1
          : this.contractModel.userQuantity;
      }
    },
    chartOptions() {
      return {
        include24hr: true,
        include7day: true,
        include30day: true,
        include90day: true,
        includeCandle: true,
        includeLine: true,
        includeLegend: false,
        contractIds: [this.tradeOptions.contractId],
      };
    },
    classModifiers() {
      return {
        'purchase-offer-sushi': true,
        'purchase-offer-sushi--maintenance': !this.isTradingEnabled,
        'purchase-offer-sushi--yes': this.tradeOptions.operationValue === 'yes',
        'purchase-offer-sushi--no': this.tradeOptions.operationValue === 'no',
        'purchase-offer-sushi--mobile-inline': true,
        [`purchase-offer-sushi--${this.$router.currentRoute.name}`]: true,
      };
    },
    contractModel() {
      return this.contract ? new Contract(this.contract) : {};
    },
    contractName() {
      if (!this.market || !this.contract) return '';
      if (isMarketSingle(this.market)) {
        return this.market.marketShortName || this.market.marketName;
      }
      return this.contract.contractName;
    },
    imageUrl() {
      return this.contractModel.contractImageSmallUrl || this.contractModel.contractImageUrl;
    },
    contractImageStyleModifiers() {
      return {
        'background-image': `url(${this.imageUrl})`,
      };
    },
    mainClassName() {
      return 'purchase-offer-sushi';
    },
    quantityErrorText() {
      const { reduced, min, max } = this.getReducedQuantity()

      if (
        this.tradeOptions.operationType === 'buy' &&
        this.quantity &&
        (this.contractModel.userQuantity + this.quantity) < min
      ) {
        const suffix = min === 1 ? 'share' : 'shares';
        return `You must own at least ${min} ${suffix} in this contract`
      }
      if (this.tradeOptions.operationType === 'sell' && this.quantity > this.contractModel.userQuantity) {
        if (this.contractModel.userQuantity === 1) {
          return 'You have only 1 share to sell';
        }
        if (this.contractModel.userQuantity === 0) {
          return "You don't have any shares to sell";
        }
        const suffix = this.contractModel.userQuantity === 1 ? 'share' : 'shares';
        return `You only have ${this.contractModel.userQuantity} ${suffix} to sell`;
      }
      if (this.tradeOptions.operationType === 'sell' && this.quantity && this.quantity < reduced) {
        const suffix = min === 1 ? 'share' : 'shares';
        return `You must maintain ownership of at least ${min} ${suffix}`
      }
      // CR
      if (this.tradeOptions.operationType === 'sell' && this.quantity && max && (this.quantity > max && this.quantity !== this.contractModel.userQuantity)) {
        const suffix = min === 1 ? 'share' : 'shares';
        return `You must maintain ownership of at least ${min} ${suffix}`
      }
      return null;
    },
    isPriceValid() {
      if (this.pricePerShare === null || isNaN(this.pricePerShare) || this.pricePerShare === 0) {
        return false;
      }
      return true;
    },
    isQuantityValid() {
      if (this.quantity === null || this.quantity === '') return false;
      if (this.tradeOptions.operationType === 'sell') {
        if (this.quantity > this.contractModel.userQuantity) return false;
      }
      return !this.quantityErrorText;
    },
    nextButtonTitle() {
      if (this.tradeOptions && this.tradeOptions.skipConfirmation) {
        return 'Submit Order';

      }
      if (this.isLayoutDesktop) {
        return 'Next';
      }
      return this.tradeTypeText;
    },
    nextButtonDisabled() {
      return isMarketClosed(this.market) ||
        this.isMarketDisabled ||
        !this.isTradingEnabled ||
        !this.isQuantityValid ||
        !this.isPriceValid ||
        !this.isAvailableForTrade ||
        this.isLoading;
    },
    purchaseOfferKey() {
      const timestamp = this.contractModel.timestamp || '-';
      return `${this.contractModel.contractId}-${timestamp}-${this.tradeSuccess.toString()}-${this.contractModel.mode}-${this.contractModel.userOpenOrders}-${this.contractModel.userQuantity}-${this.tradeOptions.operationType}-${this.tradeOptions.operationValue}`;
    },
    orderBookKey() {
      return this.purchaseOfferKey;
    },
    isContractOpen() {
      return isContractOpen(this.contract);
    },
    pricePerShareSuffix() {
      return this.tradeType <= 1 ? 'Max' : 'Min';
    },
    pricePerShareSuffixFull() {
      return this.tradeType <= 1 ? 'Maximum' : 'Minimum';
    },
    tradeType() {
      switch (`${this.tradeOptions.operationType}_${this.tradeOptions.operationValue}`) {
        case 'buy_no': return 0;
        case 'buy_yes': return 1;
        case 'sell_no': return 2;
        case 'sell_yes': return 3;
        default: return -1;
      }
    },
    tradeTypeText() {
      return this.tradeType <= 1 ? 'Buy' : 'Sell';
    },
    isYesType() {
      return this.tradeType === 1 || this.tradeType === 3;
    },
    yesNoText() {
      return this.isYesType ? 'YES' : 'NO';
    },
    tradeOperationAndValue() {
      return {
        type: this.tradeOptions.operationType,
        value: this.tradeOptions.operationValue,
      };
    },
    isAvailableForTrade() {
      if (!this.contractModel.mode) return true;
      return this.contractModel.mode === this.tradeOptions.operationValue;
    },
    showSellWarning() {
      return this.contractModel.userQuantity === 0 && this.tradeOptions.operationType === 'sell';
    },
    tradingUnavailableTheme() {
      if (this.isAfterHours) {
        return 'after-hours';
      }
      return 'maintenance';
    },
    tradingUnavailableText() {
      if (this.isAfterHours) {
        return 'Trading is not available during After-hours';
      }
      return 'Trading is not available during Maintenance mode.';
    }
  },
  watch: {
    'tradeOptions.operationType': function watchOperationType(val, oldVal) {
      this.submitDisabledBecauseOfSwitch = true;
      this.pricePerShareUpdateCount += 1;
      if (oldVal && oldVal !== val) {
        this.clearDirectionalOrderState();
      }
      this.setDefaultPrice();
      this.setDefaultQuantity();
      setTimeout(() => {
        this.submitDisabledBecauseOfSwitch = false;
      }, 500)
    },
    'tradeOptions.operationValue': function watchOperationValue(val, oldVal) {
      this.submitDisabledBecauseOfSwitch = true;
      this.pricePerShareUpdateCount += 1;
      if (oldVal && oldVal !== val) {
        this.saveDirectionalOrderState(oldVal);
      }
      this.restoreDirectionalOrderState(val);
       setTimeout(() => {
        this.submitDisabledBecauseOfSwitch = false;
      }, 500)
    },
    contractModel(value, oldValue) {
      if (
        oldValue &&
        value &&
        oldValue.contractId !== value.contractId
      ) {
        this.clearDirectionalOrderState();
      }
      if (this.cancelToggle) {
        this.setCancelToggle(false);
      }
    },
    pricePerShare(newVal, oldVal) {
      if (!this.disablePurchaseOfferWatchers) {
        this.setTradePrice(newVal);
      }

    },
    quantity(newValue, oldValue) {
      if (!this.disablePurchaseOfferWatchers) {
        this.setTradeQuantity(newValue);
      }
    },
    skipConfirmation(value) {
      this.setTradeSkipConfirmation(value);
      this.skipConfirmation = this.tradeOptions.skipConfirmation;
    },
    isQuantityValid(value) {
      if (value === true) this.quantityError = null;
    },
    masterTradeOptions(value) {
      const { quantity, pricePerShare } = value;
      this.setQuantityConsolidatingTradeOptions(quantity);
      this.setPriceConsolidatingTradeOptions(pricePerShare)
    },
    tradeSuccess(newValue, oldValue) {
      if (newValue && !oldValue) {
        this.clearDirectionalOrderState();
        this.setDefaultPrice();
        this.setDefaultQuantity();
      }
    },
  },
  methods: {
    ...mapActions('market', ['getMarketRules']),
    ...mapActions('trade', [
      'setTradeQuantity', 'setTradePrice',
      'setTradeSkipConfirmation', 'setCancelToggle',
      'setMasterTradeOptions'
    ]),
    ...mapActions('popup', ['setGenericSmallPopup', 'setCurrentSmallPopup', 'setCurrentPopupOptions']),
    shouldPreserveDirectionalOrderState() {
      return !this.isLayoutDesktop;
    },
    saveDirectionalOrderState(operationValue = this.tradeOptions.operationValue) {
      if (!this.shouldPreserveDirectionalOrderState() || !operationValue) return;

      this.directionalOrderState = {
        ...this.directionalOrderState,
        [operationValue]: {
          pricePerShare: this.pricePerShare,
          quantity: this.quantity,
        },
      };
    },
    restoreDirectionalOrderState(operationValue = this.tradeOptions.operationValue) {
      if (!this.shouldPreserveDirectionalOrderState()) {
        this.setDefaultPrice();
        this.setDefaultQuantity();
        return;
      }

      const savedState = this.directionalOrderState[operationValue];
      if (savedState) {
        this.setPriceConsolidatingTradeOptions(savedState.pricePerShare);
        this.setQuantityConsolidatingTradeOptions(savedState.quantity);
        return;
      }

      this.setDefaultPrice();
      this.setDefaultQuantity();
    },
    clearDirectionalOrderState() {
      this.directionalOrderState = {
        yes: null,
        no: null,
      };
    },
    setDefaultQuantity() {
      const { reduced } = this.getReducedQuantity();
      this.setQuantityConsolidatingTradeOptions(reduced);
    },
    setQuantityConsolidatingTradeOptions(value) {
      const currentQuantity = this.quantity;
      this.quantity = value;
      if (value !== null && this.tradeOptions.quantity === null) {
        this.setTradeQuantity(value);
      }
    },
    setDefaultPrice() {
      this.setPriceConsolidatingTradeOptions(this.getDefaultPricePerShare());
    },
    setPriceConsolidatingTradeOptions(value) {
      const currentPrice = this.pricePerShare;
      this.pricePerShare = value;
      if (value !== null && this.tradeOptions.pricePerShare === null) {
        this.setTradePrice(value);
      }
    },
    getDefaultPricePerShare() {
      let initialPrice = 0;
      // buy
      if (this.tradeOptions.operationType === 'buy') {
        if (this.tradeOptions.operationValue === 'yes') {
          initialPrice = this.contractModel.buyYesCostAsCents;
        } else {
          initialPrice = this.contractModel.buyNoCostAsCents;
        }
      } else if (this.tradeOptions.operationValue === 'yes') { // sell
        initialPrice = this.contractModel.sellYesCostAsCents;
      } else {
        initialPrice = this.contractModel.sellNoCostAsCents;
      }

      if (initialPrice === 0) {
        initialPrice = this.contractModel.lastTradePriceAsCents;
        if (initialPrice > 0 && this.tradeOptions.operationValue === 'no') {
          initialPrice = 100 - initialPrice;
        }
      }

      if (initialPrice === 0) {
        initialPrice = 50;
      }

      return initialPrice;
    },
    getReducedQuantity() {
      if (this.tradeOptions.operationType === 'sell') {
        return (this.contractModel.userQuantity === 0)
          ? {
            reduced: 1,
            min: this.minimumOwnership,
            max: null
          }
          : (this.contractModel.userQuantity > this.minimumOwnership)
            ? {
              reduced: 1,
              min: this.minimumOwnership,
              max: this.contractModel.userQuantity - this.minimumOwnership
            }
            : {
              reduced: this.contractModel.userQuantity,
              min: this.minimumOwnership,
              max: null
            }
      } else if (this.tradeOptions.operationType === 'buy') {
        return (this.contractModel.userQuantity >= this.minimumOwnership)
          ? {
            reduced: getDefaultBuyQuantity(),
            min: this.minimumOwnership,
            max: null,
          }
          : {
            reduced: Math.max(this.minimumOwnership, getDefaultBuyQuantity()),
            min: this.minimumOwnership,
            max: null,
          }
      }
    },
    onUpdatePriceAndQuantity(data) {
      this.setMasterTradeOptions({
        quantity: Math.min(data.quantity, 9999),
        pricePerShare: data.price,
      });
    },
    openThresholdInfoPopup() {
      this.setCurrentSmallPopup(MODALS.SMALL_OWNERSHIP_INFO);
      this.setCurrentPopupOptions({ shares: this.minimumOwnership });
    },
    onClickNext() {
      if (this.isQuantityValid && !this.isLoading) {
        this.$emit('submit');
      } else {
        this.quantityError = true;
      }
    },
    onClickNextButWithSkipDisabled() {
      if (this.isQuantityValid && !this.isLoading) {
        this.$emit('submit-no-skip');
      } else {
        this.quantityError = true;
      }
    },
  },
  created() {
    if (this.tradeOptions.pricePerShare !== null) {
      this.setQuantityConsolidatingTradeOptions(this.tradeOptions.quantity);
    } else {
      this.setDefaultPrice();
      this.setDefaultQuantity();
    }

    this.pricePerShare = this.tradeOptions.pricePerShare;
    this.skipConfirmation = this.tradeOptions.skipConfirmation;
  },
};



// WEBPACK FOOTER //
// ./src/components/purchase/sushi/purchase-offer-sushi/purchase-offer-sushi.js